export default __webpack_public_path__ + "static/media/SampleDebit.bcd13c6a.csv";